import script from "./CharacterBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterBlock.vue?vue&type=script&setup=true&lang=js"

import "./CharacterBlock.vue?vue&type=style&index=0&id=8b2a0ba6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b2a0ba6"]])

export default __exports__